<template>
  <div>
    <main>

      <div class="tab">
        <ul id="tab">
          <li
            class="white f16"
            v-for="(item,index) in list.tab"
            :class="tabid==index? 'cl_b3':''"
            @click="returnTop(index)"
          >
            <a class="white">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <!-- 部分一 -->
      <div class="content1">
        <div class="w content1_main">
          <div class="fl">
            <img class="fl_img1" :src="list.about.img1"/>
            <img class="fl_img2" :src="list.about.img2"/>
          </div>

          <div class="fr">
            <div class="about_top">
              <h2 class="fw red f36">关于飞天</h2>
              <p class="red f24">ABOUT FEITIAN <img src="@/assets/images/sk.png"></p>
            </div>
            <div class="about_bottom">
              <p v-for="(item,index) in list.about.intro" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>

      <!-- 部分二 -->
      <div class="content2">
        <div class="w content2_main">
          <div class="fl">
            <img class="fl_img fl" :src="list.culture.img1"/>
            <div class="fr">
              <p v-html="list.culture.intro"></p>
            </div>
          </div>

          <div class="right">
            <div v-for="(item,index) in list.culture.list" :class="top[index]">
              <p>{{ item.title }}</p>
              <span></span>
              <img :src="item.img"/>
            </div>

            <img class="fr" src="@/assets/images/lgs.png"/>

          </div>
        </div>
      </div>


      <!-- 部分三 -->
      <div class="content3">
        <div class="content3_top">
          <img src="@/assets/images/cpbt.png"/>

        </div>

        <div class=" content3_main">
          <ul>
            <li class="fl" v-for="(item,index) in list.product.content" :style="{'background':col[index]}"
                :class="index==0? 'add':''">
              <div class="fl" :style="index%2!=1? '':'background:#f5f5f5'">
                <img class="img1" :src="item.img"/>
                <img class="img2" :src="item.imgs"/>
              </div>

              <div class="fr">
                <div>
                  <p class="p1 f24" v-html="item.p1"></p>
                  <p class="p2 f16" v-for="(items,index) in item.p2" :key="index" v-html="items"></p>
                </div>
              </div>
            </li>
          </ul>

        </div>

      </div>

      <!-- 部分四 -->
      <div class="content4">
        <div class="content4_top">
          <img src="@/assets/images/ryt.png"/>
          <p class="center white f14">科技 · 创造 · 想象的理念，努力为树立行业旗帜而奋斗</p>
        </div>

        <!-- 轮播图 -->
        <div class="wrapper w">
          <swiper :options="swiperOption" class="swiper-container">
            <swiper-slide class="swiper-item" v-for="item of list.banner" :key="item.id">
              <img class="swiper-img" :src="item.img" alt="图片集"/>
              <p class="white f16" v-html="item.title"></p>

            </swiper-slide>
          </swiper>

          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>

        </div>

      </div>


    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {

      tabid: 0,
      top: [
        'd1',
        "d2",
        "d3",
      ],
      col: [
        '#1dbfbf',
        '#ffba59',
        '#30a2f2',
        '#ea68a2',
        '#3981e6',
        '#ec6b71',
      ],

      swiperOption: {
        // pagination: {
        //         el: ".swiper-pagination",
        //         clickable: true // 允许点击小圆点跳转
        //         },
        slidesPerView: 3,
        spaceBetween: 25,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }, //自动播放
        speed: 800, //滑动速度
        setWrapperSize: true,
        observeParents: true,
        paginationClickable: true, //点击分页器的指示点分页器控制Swiper切换
        loop: true, //循环
        observer: true,
        autoplayDisableOnInteraction: true //用户操作swiper之后，是否禁止autoplay
      },
      list: {
        tab: [{name: "关于飞天"}, {name: "品牌文化"}, {name: "产品流程"}, {name: "公司荣誉"}],
        about: {
          title: "石家庄飞天科技开发有限公司",
          intro: [
            "石家庄飞天科技开发有限公司致力于网站建设、微信营销、软件开发、品牌设计等服务。",
            "成立以来服务的客户有共青团河北省委、河北省地方金融监督管理局、石家庄市体育局、石家庄市应急管理局、石家庄市生态环境局、中国移动通信集团公司石家庄分公司、中共河北省委统战部、河北省残疾人联合会、衡水中铁建、建投·御湖园、河北超越健身等。公司拥有原创类软件系统十余套，在政府办公、事业单位、企业生产等领域得到了广泛的应用。",
            "“科技 · 创造 · 想象”，我们用先进的理念、专业的技术、优质的产品、贴心的服务为您创造价值，努力为树立行业旗帜而奋斗！"
          ],
          img1: require("@/assets/images/tp.png"),
          img2: require("@/assets/images/kjcz.png"),
        },

        culture: {
          img1: require("@/assets/images/ppwhbt.png"),
          intro: "品牌logo的创意来源于敦煌壁画形象、篆刻造型、中国航天等元素内容，结合了中国古代文化与现代科技的大美造型与含义。壁画中流云飞动，充满了欢乐、自由、祥和的气氛，表达了飞天文化崇尚自由、人性为本的理念。壁画与篆刻都凝聚了中华民族五千年的文化与智慧，充分体现了古人的动手创造能力。中国发展航天事业贯彻落实国家科技事业发展的指导方针，即自主创新、重点跨越、支撑发展、引领未来。这三个创意来源引出了飞天的核心理念科技、创造、想象。",
          list: [
            {
              title: "敦煌壁画",
              img: require("@/assets/images/gyl1.png"),
            },
            {
              title: "篆刻造型",
              img: require("@/assets/images/gyl2.png"),
            },
            {
              title: "中国航天",
              img: require("@/assets/images/gyl3.png"),
            },
          ]
        },

        product: {
          title: "产品流程",
          intro: "<我的产品就是这样出来的>",
          content: [
            {
              id: 1,
              img: require("@/assets/images/lc_1.png"),
              imgs: require("@/assets/images/num1.png"),
              p1: "需求沟通",
              p2: [
                "与客户进行沟通",
                "充分了解客户的需求"
              ]
            },
            {
              id: 2,
              img: require("@/assets/images/lc_2.png"),
              imgs: require("@/assets/images/num2.png"),
              p1: "创意设计",
              p2: [
                "根据客户需求",
                "设计师构思进行产品设计"
              ]
            },
            {
              id: 3,
              img: require("@/assets/images/lc_3.png"),
              imgs: require("@/assets/images/num3.png"),
              p1: "前端制作",
              p2: [
                "按照设计效果图",
                "前端程序实现显示效果"
              ]
            },
            {
              id: 4,
              img: require("@/assets/images/lc_4.png"),
              imgs: require("@/assets/images/num4.png"),
              p1: "技术开发",
              p2: [
                "开发搭建后台与前端程序结合",
                "完成网站效果"
              ]
            },
            {
              id: 5,
              img: require("@/assets/images/lc_5.png"),
              imgs: require("@/assets/images/num5.png"),
              p1: "测试调试",
              p2: [
                "进行试用和程序测试",
                "完善产品功能效果"
              ]
            },
            {
              id: 6,
              img: require("@/assets/images/lc_6.png"),
              imgs: require("@/assets/images/num6.png"),
              p1: "上线运行",
              p2: [
                "一切就绪交于客户",
                "完成上线运行使用"
              ]
            }
          ]
        },
        banner: [
          // {
          //   img:require("@/assets/images/rys1.png"),
          //   title:"企业信用等级证书"
          // },

          {
            img: require("@/assets/images/rys3.jpg"),
            title: "河北省科技型中小企业"
          },
          {
            img: require("@/assets/images/rys4.png"),
            title: "营业执照"
          },
          {
            img: require("@/assets/images/rys5.jpg"),
            title: "全城热练智慧体育管理服务平台"
          },
          {
            img: require("@/assets/images/rys6.jpg"),
            title: "危险化学品安全体系建设管理追溯系统"
          },
          {
            img: require("@/assets/images/rys7.jpg"),
            title: "环保易巡检管理系统"
          },

          // {
          //   img:require("@/assets/images/rys2.png"),
          //   title:"9000质量管理体系认证证书"
          // },
          // {
          //   img:require("@/assets/images/rys1.png"),
          //   title:"企业信用等级证书"
          // },
          //
          // {
          //   img:require("@/assets/images/rys3.jpg"),
          //   title:"河北省科技型中小企业"
          // },
          // {
          //   img:require("@/assets/images/rys4.png"),
          //   title:"营业执照"
          // },
          //
          // {
          //   img:require("@/assets/images/rys2.png"),
          //   title:"9000质量管理体系认证证书"
          // },
          //

        ],

      },
    };
  },

  mounted() {
    $('.content3_main ul li').hover(function () {
      $(this).addClass('add'), $(this).siblings().removeClass('add')
    });

    $(".tab").hide();
    $(window).bind("scroll resize", function () {
      if ($(window).scrollTop() <= 200) {
        $(".tab").fadeOut(1000);
      } else {
        $(".tab").fadeIn(1000);
      }
    });
  },
  methods: {
    returnTop: function (index) {
      this.tabid = index;
      if (this.tabid == 0) {
        $("html, body").animate({scrollTop: 0}, 800);
        return false;
      } else if (this.tabid == 1) {
        $("html, body").animate({scrollTop: 710}, 800);
      } else if (this.tabid == 2) {
        $("html, body").animate({scrollTop: 1320}, 800);
      } else if (this.tabid == 3) {
        $("html, body").animate({scrollTop: 1920}, 800);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tab {
  position: fixed;
  height: 150px;
  top: 40%;
  right: 0;
  z-index: 99;

  li:hover {
    width: 70px;
    height: 46px;
    line-height: 46px;
    transition: all 0.6s;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 125px;

    li {
      padding: 7px 18px;
      background: #b3b3b3;
      border-radius: 4px;
      width: 33px;
      height: 46px;
      margin-bottom: 5px;
      overflow: hidden;
    }

    .cl_b3 {
      background: #e50012;
    }
  }
}

.content1 {
  background: url(../../assets/images/hbj.png) no-repeat;
  min-height: 710px;
  background-size: 100% 100%;
  background-position: top left;

  .content1_main {
    padding: 60px 0;
    overflow: hidden;
    position: relative;

    .fl {
      position: relative;

      .fl_img1 {
        width: 400px;

      }

      .fl_img2 {
        position: absolute;
        left: 120px;
        bottom: -60px;
        width: 1000px;
      }
    }

    .fr {
      width: 670px;

      .about_top {
        padding: 20px 0 30px;

        p {
          font-style: italic;
          padding-left: 40px;
          display: flex;
          align-items: center;

          img {
            margin-left: 15px;
          }
        }

      }

      .about_bottom {
        text-indent: 2em;
        padding: 15px 0;
        border-top: 2px solid #e50012;
        line-height: 45px;
      }
    }
  }
}

/* 2 */
.content2 {
  .content2_main {
    overflow: hidden;
    padding: 80px 0;

    .fl {
      img {
        width: 88px;
      }

      div {
        padding: 45px 60px;
        width: 450px;
        line-height: 45px;
        text-indent: 2em;
      }
    }

    .right {
      width: 542px;
      float: left;
      position: relative;

      .d1 {
        top: 0px;
        left: 50px
      }

      .d2 {
        top: 160px;
        left: 0px
      }

      .d3 {
        top: 310px;
        left: 50px
      }

      div {
        position: absolute;
        width: 235px;
        display: flex;
        align-items: center;

        span {
          transition: all 0.5s;
          width: 6px;
          height: 6px;
          background: #999999;
          border-radius: 100%;
          margin: 0 20px 0 10px;
        }

        img {
          width: 110px;
          transition: all 0.5s;
        }

        p {
          color: #999999;
          width: 84px;
        }
      }

      div:hover {
        img {
          transform: scale(1.1);
        }

        span {
          width: 10px;
          height: 10px;
          background: #e50012;
        }

        p {
          color: #e50012;
          font-size: 20px;
        }
      }

      .fr {
        position: absolute;
        top: 100px;
        left: 265px;
        width: 275px;
      }
    }
  }

}

/* 3 */
.content3 {
  text-align: center;

  .content3_top {
    background: url(../../assets/images/cplcbj.png);
    height: 260px;
    background-size: 100% 100%;
    background-position: top left;
    overflow: hidden;


    img {
      display: block;
      width: 670px;
      margin: 60px auto 0;
    }
  }

  .content3_main {
    display: inline-block;
    margin: -35px auto 80px;

    ul {
      overflow: hidden;
      box-shadow: 0px 1px 6px 2px #999;

      li {
        width: 160px;
        overflow: hidden;
        transition: all .5s;
        height: 290px;

        .fl {
          padding: 60px 30px;
          background: #f0f0f0;

          .img1 {
            width: 100px;
            margin: 0 auto 20px;
            display: block;
          }
        }


        .fr {
          text-align: left;
          padding: 0 30px;
          color: #fff;
          width: 145px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;

          .p1 {
            margin-bottom: 20px;
          }

          .p2 {
            line-height: 35px;
          }
        }

      }

      .add {
        width: 365px;
      }

      /* li:hover{
          width:365px ;
        } */
    }
  }
}

.content4 {
  background: url(../../assets/images/ryzsbj.png);
  background-size: 100% 100%;
  background-position: top left;
  overflow: hidden;
  height: 635px;

  .content4_top {
    img {
      width: 405px;
      margin: 80px auto 30px;
      display: block;
    }
  }

  .wrapper {
    margin: 0 auto 80px;
    padding-top: 60px;
    border-radius: 5px;
    position: relative;

    p {
      margin: 20px 0;
    }

    .swiper-slide {
      text-align: center;
    }

    .swiper-img {
      /* width:165px; */
      height: 220px;
      margin: 0 auto;
    }


    .swiper-item {
      opacity: .5;
      height: 380px !important;
      transform: scale(0.8);
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column !important;

      img {
        display: block;
        border: 10px solid #fff;
        border-radius: 5px;
      }

      p {
        display: block;
        overflow: hidden;
      }
    }

    .swiper-slide-active {
      opacity: 1;
      transform: scale(1);
    }

    .swiper-button-next {
      background: url(../../assets/images/ban_r.png);
      right: -40px;
      outline: none
    }

    .swiper-button-prev {
      background: url(../../assets/images/ban_l.png);
      left: -40px;
      outline: none
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/pc/about.vue